import React from "react"
import tw from "twin.macro"

const CompChartHeading = (props) => {
    return (
        <li
            css={tw`font-semibold py-4 pl-8 border-t border-l-0 border-r-0 border-b-0 border-solid border-grey-300`}
            css={props.centred && tw`text-center underline`}
        >
            <p>{props.heading}</p>
        </li>
    )
}

export default CompChartHeading
